@if (!organisation.projects?.length) {
    <p class="empty">There are no projects yet. Projects let you model a future state or change for the organisation without affecting current state.</p>
}@else {
    <app-table [columns]="columns" [data]="data" [rowSelect]="true" (rowEvent)="handleRowEvent($event)"></app-table>
}
